import React from 'react';
import { Link } from 'react-router-dom';
export function AppFooter() {
  const handleLinkClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer className="w-full bg-purple border-t-brutal border-[#1A1A1A] mt-16" data-id="element-17">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8 py-8" data-id="element-18">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6" data-id="element-19">
          {/* Brand */}
          <div data-id="element-20">
            <h3 className="font-display text-xl font-bold text-yellow uppercase tracking-tight mb-2" data-id="element-21">
              (Not) Parásitos
            </h3>
            <p className="text-sm text-white/80" data-id="element-22">
              Desparasitemos el debate público.
            </p>
          </div>

          {/* Links */}
          <nav className="flex flex-wrap gap-6" data-id="element-23">
            <Link to="/about" onClick={handleLinkClick} className="font-display text-sm uppercase tracking-wide font-bold text-white hover:text-yellow transition-colors duration-100" data-id="element-24">
              Sobre Nosotros
            </Link>
            <Link to="/privacy-policy" onClick={handleLinkClick} className="font-display text-sm uppercase tracking-wide font-bold text-white hover:text-yellow transition-colors duration-100" data-id="element-25">
              Política de Privacidad
            </Link>
          </nav>
        </div>

        {/* Copyright */}
        <div className="mt-6 pt-6 border-t-2 border-yellow/20" data-id="element-26">
          <p className="text-xs text-white/60 text-center md:text-left" data-id="element-27">
            © {new Date().getFullYear()} (Not) Parásitos. Todos los datos
            provienen de fuentes públicas oficiales.
          </p>
        </div>
      </div>
    </footer>;
}